// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_module = require("rescript/lib/js/caml_module.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var DOM$SmartcutsMacros = require("../../DOM.bs.js");
var Log$SmartcutsMacros = require("../../Log.bs.js");
var Util$SmartcutsMacros = require("../../../../bs-utils/src/Util.bs.js");
var Selector$SmartcutsMacros = require("../../Selector.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../../../bs-utils/src/DeccoUtils.bs.js");
var JsExnUtils$SmartcutsMacros = require("../../../../bs-utils/src/JsExnUtils.bs.js");
var RenderOnHost$SmartcutsMacros = require("../../RenderOnHost.bs.js");
var StateMachine$SmartcutsMacros = require("../../StateMachine.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("../../DOM__HtmlElement.bs.js");
var InnerTextSemantic$SmartcutsMacros = require("../../semantics/InnerTextSemantic.bs.js");
var ExtensionMessaging$SmartcutsMacros = require("../../ExtensionMessaging.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../../../bs-utils/src/JsPromiseErrorUtils.bs.js");
var RenderOnHost__Geometry$SmartcutsMacros = require("../../RenderOnHost__Geometry.bs.js");
var ExtensionMessagingBuilders$SmartcutsMacros = require("../../ExtensionMessagingBuilders.bs.js");
var ExtensionMessaging__FromTab$SmartcutsMacros = require("../../ExtensionMessaging__FromTab.bs.js");
var DOM__Event__ForSerialization$SmartcutsMacros = require("../../DOM__Event__ForSerialization.bs.js");
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = require("../../InterfaceBtwnContentScriptAndBg.bs.js");
var ExtensionMessaging__FromExtension$SmartcutsMacros = require("../../ExtensionMessaging__FromExtension.bs.js");
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = require("./ContentScript__StateMachine__Shared__Types.bs.js");
var ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros = require("./PlaybackMode/ContentScript__StateMachine__PlaybackMode__Types.bs.js");
var ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros = require("./RecordingMode/ContentScript__StateMachine__RecordingMode__Types.bs.js");
var ExtensionMessaging__FromTab__WithStateMachineDeps$SmartcutsMacros = require("../../ExtensionMessaging__FromTab__WithStateMachineDeps.bs.js");
var ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros = require("./UrlTriggeringMode/ContentScript__StateMachine__UrlTriggeringMode__Types.bs.js");
var ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros = require("./DataExtractionMode/ContentScript__StateMachine__DataExtractionMode__Types.bs.js");

var Generic = Caml_module.init_mod([
      "ContentScript__StateMachine__Types.re",
      319,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "listener_encode"
        ],
        [
          /* Function */0,
          "listener_decode"
        ],
        [
          /* Function */0,
          "contentScriptIdle_encode"
        ],
        [
          /* Function */0,
          "contentScriptIdle_decode"
        ],
        [
          /* Function */0,
          "state_encode"
        ],
        [
          /* Function */0,
          "state_decode"
        ],
        [
          /* Function */0,
          "event_encode"
        ],
        [
          /* Function */0,
          "event_decode"
        ],
        [
          /* Function */0,
          "errorContext_encode"
        ],
        [
          /* Function */0,
          "errorContext_decode"
        ],
        [
          /* Function */0,
          "failure_encode"
        ],
        [
          /* Function */0,
          "failure_decode"
        ],
        [
          /* Function */0,
          "otherFailureReason_encode"
        ],
        [
          /* Function */0,
          "otherFailureReason_decode"
        ],
        [
          /* Function */0,
          "sideEffect_encode"
        ],
        [
          /* Function */0,
          "sideEffect_decode"
        ]
      ]
    });

var ForSerialization = Caml_module.init_mod([
      "ContentScript__StateMachine__Types.re",
      703,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "listener_encode"
        ],
        [
          /* Function */0,
          "listener_decode"
        ],
        [
          /* Function */0,
          "state_encode"
        ],
        [
          /* Function */0,
          "state_decode"
        ],
        [
          /* Function */0,
          "event_encode"
        ],
        [
          /* Function */0,
          "event_decode"
        ],
        [
          /* Function */0,
          "sideEffect_encode"
        ],
        [
          /* Function */0,
          "sideEffect_decode"
        ],
        [
          /* Function */0,
          "errorContext_encode"
        ],
        [
          /* Function */0,
          "errorContext_decode"
        ],
        [
          /* Function */0,
          "failure_encode"
        ],
        [
          /* Function */0,
          "failure_decode"
        ],
        [
          /* Function */0,
          "otherFailureReason_encode"
        ],
        [
          /* Function */0,
          "otherFailureReason_decode"
        ],
        [
          /* Function */0,
          "failureInfo_encode"
        ],
        [
          /* Function */0,
          "failureInfo_decode"
        ]
      ]
    });

var ExtensionMessagingFromTabWithStateMachineDeps = Caml_module.init_mod([
      "ContentScript__StateMachine__Types.re",
      836,
      2
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "message_encode"
              ],
              [
                /* Function */0,
                "message_decode"
              ],
              [
                /* Function */0,
                "response_encode"
              ],
              [
                /* Function */0,
                "response_decode"
              ]
            ]
          },
          "MR_NotifyBgOfContentScriptFailure"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "message_encode"
              ],
              [
                /* Function */0,
                "message_decode"
              ],
              [
                /* Function */0,
                "response_encode"
              ],
              [
                /* Function */0,
                "response_decode"
              ],
              [
                /* Function */0,
                "responseError_encode"
              ],
              [
                /* Function */0,
                "responseError_decode"
              ],
              [
                /* Function */0,
                "result__encode"
              ],
              [
                /* Function */0,
                "result__decode"
              ],
              [
                /* Function */0,
                "respondToSender_encode"
              ],
              [
                /* Function */0,
                "respondToSender_decode"
              ],
              [
                /* Function */0,
                "makeRespondToBg"
              ],
              [
                /* Function */0,
                "encodeAndSendMessage"
              ],
              [
                /* Function */0,
                "encodeAndSendMessageToExtensionId"
              ]
            ]
          },
          "NotifyBgOfContentScriptFailure"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "message_encode"
              ],
              [
                /* Function */0,
                "message_decode"
              ],
              [
                /* Function */0,
                "response_encode"
              ],
              [
                /* Function */0,
                "response_decode"
              ]
            ]
          },
          "MR_NotifyBgOfContentScriptResponseFailure"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "message_encode"
              ],
              [
                /* Function */0,
                "message_decode"
              ],
              [
                /* Function */0,
                "response_encode"
              ],
              [
                /* Function */0,
                "response_decode"
              ],
              [
                /* Function */0,
                "responseError_encode"
              ],
              [
                /* Function */0,
                "responseError_decode"
              ],
              [
                /* Function */0,
                "result__encode"
              ],
              [
                /* Function */0,
                "result__decode"
              ],
              [
                /* Function */0,
                "respondToSender_encode"
              ],
              [
                /* Function */0,
                "respondToSender_decode"
              ],
              [
                /* Function */0,
                "makeRespondToBg"
              ],
              [
                /* Function */0,
                "encodeAndSendMessage"
              ],
              [
                /* Function */0,
                "encodeAndSendMessageToExtensionId"
              ]
            ]
          },
          "NotifyBgOfContentScriptResponseFailure"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "message_encode"
              ],
              [
                /* Function */0,
                "message_decode"
              ],
              [
                /* Function */0,
                "response_encode"
              ],
              [
                /* Function */0,
                "response_decode"
              ]
            ]
          },
          "MR_All"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "message_encode"
              ],
              [
                /* Function */0,
                "message_decode"
              ],
              [
                /* Function */0,
                "response_encode"
              ],
              [
                /* Function */0,
                "response_decode"
              ]
            ]
          },
          "All"
        ]
      ]
    });

var ExtensionMessagingFromTabAll = Caml_module.init_mod([
      "ContentScript__StateMachine__Types.re",
      899,
      4
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "message_encode"
        ],
        [
          /* Function */0,
          "message_decode"
        ],
        [
          /* Function */0,
          "response_encode"
        ],
        [
          /* Function */0,
          "response_decode"
        ],
        [
          /* Function */0,
          "responseError_encode"
        ],
        [
          /* Function */0,
          "responseError_decode"
        ],
        [
          /* Function */0,
          "result__encode"
        ],
        [
          /* Function */0,
          "result__decode"
        ],
        [
          /* Function */0,
          "respondToSender_encode"
        ],
        [
          /* Function */0,
          "respondToSender_decode"
        ],
        [
          /* Function */0,
          "onMessageToExtension"
        ],
        [
          /* Function */0,
          "onMessageExternal"
        ],
        [
          /* Function */0,
          "makeNestedRespondToTabFromRootRespondToTab"
        ],
        [
          /* Function */0,
          "makeRootRespondToTabFromNestedRespondToTab"
        ]
      ]
    });

function listener_encode(encoder_domEvent, encoder_domMutationRecord, v) {
  if (typeof v === "number") {
    if (v === /* NoListener */0) {
      return ["NoListener"];
    } else {
      return ["ContextMenuDomEventListener"];
    }
  }
  switch (v.TAG | 0) {
    case /* MessageFromExtensionListener */0 :
        return [
                "MessageFromExtensionListener",
                ExtensionMessaging__FromExtension$SmartcutsMacros.All.message_encode(v._0),
                ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._1),
                ExtensionMessaging$SmartcutsMacros.rejectToBg_encode(v._2)
              ];
    case /* RecordingModeListener */1 :
        return [
                "RecordingModeListener",
                ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.Generic.listener_encode(encoder_domEvent, encoder_domMutationRecord, v._0)
              ];
    case /* UrlTriggeringModeListener */2 :
        return [
                "UrlTriggeringModeListener",
                ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.listener_encode(v._0)
              ];
    case /* DataExtractionModeListener */3 :
        return [
                "DataExtractionModeListener",
                ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.listener_encode(encoder_domMutationRecord, v._0)
              ];
    
  }
}

function listener_decode(decoder_domEvent, decoder_domMutationRecord, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ContextMenuDomEventListener" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ContextMenuDomEventListener */1
                  };
          }
      case "DataExtractionModeListener" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.listener_decode(decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DataExtractionModeListener */3,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "MessageFromExtensionListener" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.message_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = ExtensionMessaging$SmartcutsMacros.rejectToBg_decode(Belt_Array.getExn(jsonArr$1, 3));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* MessageFromExtensionListener */0,
                          _0: match$1._0,
                          _1: match$2._0,
                          _2: match$3._0
                        }
                      };
              }
              var e$1 = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "NoListener" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoListener */0
                  };
          }
      case "RecordingModeListener" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.Generic.listener_decode(decoder_domEvent, decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RecordingModeListener */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$4 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "UrlTriggeringModeListener" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.listener_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UrlTriggeringModeListener */2,
                      _0: v0$2._0
                    }
                  };
          }
          var e$5 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function contentScriptIdle_encode(encoder_htmlElement, v) {
  return Js_dict.fromArray([
              [
                "lastContextMenuTarget",
                Decco.optionToJson(encoder_htmlElement, v.lastContextMenuTarget)
              ],
              [
                "disconnectLinkTriggerListener",
                Decco.optionToJson(DeccoUtils$SmartcutsMacros.unitToUnit_encode, v.disconnectLinkTriggerListener)
              ]
            ]);
}

function contentScriptIdle_decode(decoder_htmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var lastContextMenuTarget = Decco.optionFromJson(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastContextMenuTarget"), null));
  if (lastContextMenuTarget.TAG === /* Ok */0) {
    var disconnectLinkTriggerListener = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.unitToUnit_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "disconnectLinkTriggerListener"), null));
    if (disconnectLinkTriggerListener.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                lastContextMenuTarget: lastContextMenuTarget._0,
                disconnectLinkTriggerListener: disconnectLinkTriggerListener._0
              }
            };
    }
    var e = disconnectLinkTriggerListener._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".disconnectLinkTriggerListener" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = lastContextMenuTarget._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".lastContextMenuTarget" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function state_encode(encoder_recordingState, encoder_htmlElement, encoder_domEvent, v) {
  if (typeof v === "number") {
    if (v === /* Init */0) {
      return ["Init"];
    } else {
      return ["ExtensionContextInvalidated"];
    }
  }
  switch (v.TAG | 0) {
    case /* WaitingForBgToAckContentScriptReady */0 :
        return [
                "WaitingForBgToAckContentScriptReady",
                contentScriptIdle_encode(encoder_htmlElement, v._0)
              ];
    case /* ContentScriptIdle */1 :
        return [
                "ContentScriptIdle",
                contentScriptIdle_encode(encoder_htmlElement, v._0)
              ];
    case /* RecordingMode */2 :
        return [
                "RecordingMode",
                Curry._1(encoder_recordingState, v._0)
              ];
    case /* PlaybackMode */3 :
        return [
                "PlaybackMode",
                ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros.Generic.state_encode(encoder_htmlElement, encoder_domEvent, v._0)
              ];
    case /* UrlTriggeringMode */4 :
        return [
                "UrlTriggeringMode",
                ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.state_encode(encoder_htmlElement, encoder_domEvent, v._0)
              ];
    case /* DataExtractionMode */5 :
        return [
                "DataExtractionMode",
                ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.state_encode(encoder_htmlElement, v._0)
              ];
    
  }
}

function state_decode(decoder_recordingState, decoder_htmlElement, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ContentScriptIdle" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = contentScriptIdle_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ContentScriptIdle */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DataExtractionMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.state_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DataExtractionMode */5,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ExtensionContextInvalidated" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ExtensionContextInvalidated */1
                  };
          }
      case "Init" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Init */0
                  };
          }
      case "PlaybackMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros.Generic.state_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PlaybackMode */3,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "RecordingMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Curry._1(decoder_recordingState, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RecordingMode */2,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "UrlTriggeringMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.state_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UrlTriggeringMode */4,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "WaitingForBgToAckContentScriptReady" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = contentScriptIdle_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* WaitingForBgToAckContentScriptReady */0,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function event_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v) {
  if (typeof v === "number") {
    return ["Initialize"];
  }
  switch (v.TAG | 0) {
    case /* BasicEventRootLevel */0 :
        return [
                "BasicEventRootLevel",
                ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
              ];
    case /* BgDidAckContentScriptReady */1 :
        return [
                "BgDidAckContentScriptReady",
                Curry._1(ExtensionMessaging__FromTab$SmartcutsMacros.ContentScriptReady.result__encode, v._0)
              ];
    case /* DidRespondToBgWithContentScriptFailureId */2 :
        return [
                "DidRespondToBgWithContentScriptFailureId",
                InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_encode(v._0),
                Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, otherFailureReason_encode, v._1),
                errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._2)
              ];
    case /* DidSetupLinkTriggerListener */3 :
        return [
                "DidSetupLinkTriggerListener",
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
              ];
    case /* RecordingModeEvent */4 :
        return [
                "RecordingModeEvent",
                Curry._1(encoder_recordingEvent, v._0)
              ];
    case /* PlaybackModeEvent */5 :
        return [
                "PlaybackModeEvent",
                ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros.Generic.event_encode(encoder_htmlElement, encoder_domEvent, v._0)
              ];
    case /* UrlTriggeringModeEvent */6 :
        return [
                "UrlTriggeringModeEvent",
                ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.event_encode(encoder_htmlElement, encoder_domEvent, v._0)
              ];
    case /* DataExtractionModeEvent */7 :
        return [
                "DataExtractionModeEvent",
                ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.event_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v._0)
              ];
    case /* Fail */8 :
        return [
                "Fail",
                failure_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._0)
              ];
    case /* ContextMenuEventDidFireOnElement */9 :
        return [
                "ContextMenuEventDidFireOnElement",
                Curry._1(encoder_htmlElement, v._0)
              ];
    
  }
}

function event_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BasicEventRootLevel" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* BasicEventRootLevel */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "BgDidAckContentScriptReady" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(ExtensionMessaging__FromTab$SmartcutsMacros.ContentScriptReady.result__decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* BgDidAckContentScriptReady */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ContextMenuEventDidFireOnElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._1(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ContextMenuEventDidFireOnElement */9,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "DataExtractionModeEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.event_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DataExtractionModeEvent */7,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "DidRespondToBgWithContentScriptFailureId" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 3));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* DidRespondToBgWithContentScriptFailureId */2,
                          _0: match$1._0,
                          _1: match$2._0,
                          _2: match$3._0
                        }
                      };
              }
              var e$4 = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "DidSetupLinkTriggerListener" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidSetupLinkTriggerListener */3,
                      _0: v0$4._0
                    }
                  };
          }
          var e$7 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "Fail" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = failure_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Fail */8,
                      _0: v0$5._0
                    }
                  };
          }
          var e$8 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "Initialize" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Initialize */0
                  };
          }
      case "PlaybackModeEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros.Generic.event_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PlaybackModeEvent */5,
                      _0: v0$6._0
                    }
                  };
          }
          var e$9 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "RecordingModeEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = Curry._1(decoder_recordingEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RecordingModeEvent */4,
                      _0: v0$7._0
                    }
                  };
          }
          var e$10 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "UrlTriggeringModeEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.event_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UrlTriggeringModeEvent */6,
                      _0: v0$8._0
                    }
                  };
          }
          var e$11 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, (function (param) {
                return state_encode(encoder_recordingState, encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, param);
              }), (function (param) {
                return sideEffect_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, param);
              }), (function (param) {
                return listener_encode(encoder_domEvent, encoder_domMutationRecord, param);
              }), v);
}

function errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, (function (param) {
                return state_decode(decoder_recordingState, decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, param);
              }), (function (param) {
                return sideEffect_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, param);
              }), (function (param) {
                return listener_decode(decoder_domEvent, decoder_domMutationRecord, param);
              }), v);
}

function failure_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, (function (param) {
                return state_encode(encoder_recordingState, encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, param);
              }), (function (param) {
                return sideEffect_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, param);
              }), (function (param) {
                return listener_encode(encoder_domEvent, encoder_domMutationRecord, param);
              }), otherFailureReason_encode, v);
}

function failure_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, (function (param) {
                return state_decode(decoder_recordingState, decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, param);
              }), (function (param) {
                return sideEffect_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, param);
              }), (function (param) {
                return listener_decode(decoder_domEvent, decoder_domMutationRecord, param);
              }), otherFailureReason_decode, v);
}

var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;

var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;

function sideEffect_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* ResetStateMachineHistory */0 :
          return ["ResetStateMachineHistory"];
      case /* NotifyBgThatContentScriptReady */1 :
          return ["NotifyBgThatContentScriptReady"];
      case /* SetupLinkTriggerListener */2 :
          return ["SetupLinkTriggerListener"];
      case /* RemoveRenderedContent */3 :
          return ["RemoveRenderedContent"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* Dispatch */0 :
          return [
                  "Dispatch",
                  event_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._0)
                ];
      case /* NotifyBgOfContentScriptFailure */1 :
          return [
                  "NotifyBgOfContentScriptFailure",
                  Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, otherFailureReason_encode, v._0),
                  errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._1)
                ];
      case /* NotifyBgOfContentScriptResponseFailure */2 :
          return [
                  "NotifyBgOfContentScriptResponseFailure",
                  InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_encode(v._0),
                  Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, otherFailureReason_encode, v._1),
                  errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._2)
                ];
      case /* TeardownLinkTriggerListener */3 :
          return [
                  "TeardownLinkTriggerListener",
                  DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
                ];
      case /* RecordingModeSideEffect */4 :
          return [
                  "RecordingModeSideEffect",
                  Curry._1(encoder_recordingSideEffect, v._0)
                ];
      case /* PlaybackModeSideEffect */5 :
          return [
                  "PlaybackModeSideEffect",
                  ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros.Generic.sideEffect_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
      case /* UrlTriggeringModeSideEffect */6 :
          return [
                  "UrlTriggeringModeSideEffect",
                  ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.sideEffect_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
      case /* DataExtractionModeSideEffect */7 :
          return [
                  "DataExtractionModeSideEffect",
                  ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.sideEffect_encode(encoder_htmlElement, encoder_domMutationRecord, encoder_domEvent, v._0)
                ];
      case /* WindowAlert */8 :
          return [
                  "WindowAlert",
                  Decco.stringToJson(v._0)
                ];
      case /* ConsoleJsPromiseError */9 :
          return [
                  "ConsoleJsPromiseError",
                  Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                  errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._1)
                ];
      case /* ConsoleJsExn */10 :
          return [
                  "ConsoleJsExn",
                  JsExnUtils$SmartcutsMacros.t_encode(v._0),
                  errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._1)
                ];
      case /* RespondToBg */11 :
          return [
                  "RespondToBg",
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_encode(v._1)
                ];
      case /* RespondToBgWithFailure */12 :
          return [
                  "RespondToBgWithFailure",
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                  Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_encode, otherFailureReason_encode, v._1),
                  errorContext_encode(encoder_domEvent, encoder_domMutationRecord, encoder_recordingState, encoder_recordingEvent, encoder_recordingSideEffect, encoder_htmlElement, v._2)
                ];
      case /* RenderOnHostPage */13 :
          return [
                  "RenderOnHostPage",
                  RenderOnHost$SmartcutsMacros.t_encode(v._0)
                ];
      case /* RenderHtmlMarkup */14 :
          return [
                  "RenderHtmlMarkup",
                  Decco.stringToJson(v._0)
                ];
      case /* UpdateRenderedContentGeometry */15 :
          return [
                  "UpdateRenderedContentGeometry",
                  RenderOnHost__Geometry$SmartcutsMacros.t_encode(v._0)
                ];
      case /* CheckIfElementExistsOnPageAndRespond */16 :
          return [
                  "CheckIfElementExistsOnPageAndRespond",
                  Selector$SmartcutsMacros.elementSelector_encode(v._0),
                  Decco.optionToJson(InnerTextSemantic$SmartcutsMacros.t_encode, v._1),
                  Curry._1(ExtensionMessaging__FromExtension$SmartcutsMacros.DoesElementExistOnPage.respondToSender_encode, v._2)
                ];
      
    }
  }
}

function sideEffect_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CheckIfElementExistsOnPageAndRespond" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Selector$SmartcutsMacros.elementSelector_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.optionFromJson(InnerTextSemantic$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = Curry._1(ExtensionMessaging__FromExtension$SmartcutsMacros.DoesElementExistOnPage.respondToSender_decode, Belt_Array.getExn(jsonArr$1, 3));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* CheckIfElementExistsOnPageAndRespond */16,
                          _0: match$1._0,
                          _1: match$2._0,
                          _2: match$3._0
                        }
                      };
              }
              var e = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "ConsoleJsExn" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$4 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$5 = errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 2));
          if (match$4.TAG === /* Ok */0) {
            if (match$5.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ConsoleJsExn */10,
                        _0: match$4._0,
                        _1: match$5._0
                      }
                    };
            }
            var e$3 = match$5._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$3.path,
                      message: e$3.message,
                      value: e$3.value
                    }
                  };
          }
          var e$4 = match$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "ConsoleJsPromiseError" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$6 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$7 = errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 2));
          if (match$6.TAG === /* Ok */0) {
            if (match$7.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ConsoleJsPromiseError */9,
                        _0: match$6._0,
                        _1: match$7._0
                      }
                    };
            }
            var e$5 = match$7._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = match$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "DataExtractionModeSideEffect" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ContentScript__StateMachine__DataExtractionMode__Types$SmartcutsMacros.Generic.sideEffect_decode(decoder_htmlElement, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DataExtractionModeSideEffect */7,
                      _0: v0._0
                    }
                  };
          }
          var e$7 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "Dispatch" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = event_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Dispatch */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$8 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "NotifyBgOfContentScriptFailure" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$8 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$9 = errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 2));
          if (match$8.TAG === /* Ok */0) {
            if (match$9.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* NotifyBgOfContentScriptFailure */1,
                        _0: match$8._0,
                        _1: match$9._0
                      }
                    };
            }
            var e$9 = match$9._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$9.path,
                      message: e$9.message,
                      value: e$9.value
                    }
                  };
          }
          var e$10 = match$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "NotifyBgOfContentScriptResponseFailure" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$10 = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$11 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 2));
          var match$12 = errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 3));
          if (match$10.TAG === /* Ok */0) {
            if (match$11.TAG === /* Ok */0) {
              if (match$12.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* NotifyBgOfContentScriptResponseFailure */2,
                          _0: match$10._0,
                          _1: match$11._0,
                          _2: match$12._0
                        }
                      };
              }
              var e$11 = match$12._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                      }
                    };
            }
            var e$12 = match$11._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$12.path,
                      message: e$12.message,
                      value: e$12.value
                    }
                  };
          }
          var e$13 = match$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "NotifyBgThatContentScriptReady" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotifyBgThatContentScriptReady */1
                  };
          }
      case "PlaybackModeSideEffect" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = ContentScript__StateMachine__PlaybackMode__Types$SmartcutsMacros.Generic.sideEffect_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PlaybackModeSideEffect */5,
                      _0: v0$2._0
                    }
                  };
          }
          var e$14 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "RecordingModeSideEffect" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Curry._1(decoder_recordingSideEffect, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RecordingModeSideEffect */4,
                      _0: v0$3._0
                    }
                  };
          }
          var e$15 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      case "RemoveRenderedContent" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RemoveRenderedContent */3
                  };
          }
      case "RenderHtmlMarkup" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RenderHtmlMarkup */14,
                      _0: v0$4._0
                    }
                  };
          }
          var e$16 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
      case "RenderOnHostPage" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = RenderOnHost$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RenderOnHostPage */13,
                      _0: v0$5._0
                    }
                  };
          }
          var e$17 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "ResetStateMachineHistory" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ResetStateMachineHistory */0
                  };
          }
      case "RespondToBg" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$13 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$14 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$13.TAG === /* Ok */0) {
            if (match$14.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* RespondToBg */11,
                        _0: match$13._0,
                        _1: match$14._0
                      }
                    };
            }
            var e$18 = match$14._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$18.path,
                      message: e$18.message,
                      value: e$18.value
                    }
                  };
          }
          var e$19 = match$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                  }
                };
      case "RespondToBgWithFailure" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$15 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$16 = Curry._2(StateMachine$SmartcutsMacros.Failure.FailWith.t_decode, otherFailureReason_decode, Belt_Array.getExn(jsonArr$1, 2));
          var match$17 = errorContext_decode(decoder_domEvent, decoder_domMutationRecord, decoder_recordingState, decoder_recordingEvent, decoder_recordingSideEffect, decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 3));
          if (match$15.TAG === /* Ok */0) {
            if (match$16.TAG === /* Ok */0) {
              if (match$17.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* RespondToBgWithFailure */12,
                          _0: match$15._0,
                          _1: match$16._0,
                          _2: match$17._0
                        }
                      };
              }
              var e$20 = match$17._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$20.path,
                        message: e$20.message,
                        value: e$20.value
                      }
                    };
            }
            var e$21 = match$16._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$21.path,
                      message: e$21.message,
                      value: e$21.value
                    }
                  };
          }
          var e$22 = match$15._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$22.path,
                    message: e$22.message,
                    value: e$22.value
                  }
                };
      case "SetupLinkTriggerListener" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SetupLinkTriggerListener */2
                  };
          }
      case "TeardownLinkTriggerListener" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TeardownLinkTriggerListener */3,
                      _0: v0$6._0
                    }
                  };
          }
          var e$23 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$23.path,
                    message: e$23.message,
                    value: e$23.value
                  }
                };
      case "UpdateRenderedContentGeometry" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = RenderOnHost__Geometry$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpdateRenderedContentGeometry */15,
                      _0: v0$7._0
                    }
                  };
          }
          var e$24 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$24.path,
                    message: e$24.message,
                    value: e$24.value
                  }
                };
      case "UrlTriggeringModeSideEffect" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = ContentScript__StateMachine__UrlTriggeringMode__Types$SmartcutsMacros.Generic.sideEffect_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UrlTriggeringModeSideEffect */6,
                      _0: v0$8._0
                    }
                  };
          }
          var e$25 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$25.path,
                    message: e$25.message,
                    value: e$25.value
                  }
                };
      case "WindowAlert" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* WindowAlert */8,
                      _0: v0$9._0
                    }
                  };
          }
          var e$26 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$26.path,
                    message: e$26.message,
                    value: e$26.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "listener_encode"
        ],
        [
          /* Function */0,
          "listener_decode"
        ],
        [
          /* Function */0,
          "contentScriptIdle_encode"
        ],
        [
          /* Function */0,
          "contentScriptIdle_decode"
        ],
        [
          /* Function */0,
          "state_encode"
        ],
        [
          /* Function */0,
          "state_decode"
        ],
        [
          /* Function */0,
          "event_encode"
        ],
        [
          /* Function */0,
          "event_decode"
        ],
        [
          /* Function */0,
          "errorContext_encode"
        ],
        [
          /* Function */0,
          "errorContext_decode"
        ],
        [
          /* Function */0,
          "failure_encode"
        ],
        [
          /* Function */0,
          "failure_decode"
        ],
        [
          /* Function */0,
          "otherFailureReason_encode"
        ],
        [
          /* Function */0,
          "otherFailureReason_decode"
        ],
        [
          /* Function */0,
          "sideEffect_encode"
        ],
        [
          /* Function */0,
          "sideEffect_decode"
        ]
      ]
    }, Generic, {
      listener_encode: listener_encode,
      listener_decode: listener_decode,
      contentScriptIdle_encode: contentScriptIdle_encode,
      contentScriptIdle_decode: contentScriptIdle_decode,
      state_encode: state_encode,
      state_decode: state_decode,
      event_encode: event_encode,
      event_decode: event_decode,
      errorContext_encode: errorContext_encode,
      errorContext_decode: errorContext_decode,
      failure_encode: failure_encode,
      failure_decode: failure_decode,
      otherFailureReason_encode: otherFailureReason_encode,
      otherFailureReason_decode: otherFailureReason_decode,
      sideEffect_encode: sideEffect_encode,
      sideEffect_decode: sideEffect_decode
    });

function listener_encode$1(v) {
  return Curry._3(Generic.listener_encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, v);
}

function listener_decode$1(v) {
  return Curry._3(Generic.listener_decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, v);
}

function state_encode$1(v) {
  return Curry._4(Generic.state_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}

function state_decode$1(v) {
  return Curry._4(Generic.state_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}

function event_encode$1(v) {
  return Curry._7(Generic.event_encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, v);
}

function event_decode$1(v) {
  return Curry._7(Generic.event_decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, v);
}

function sideEffect_encode$1(v) {
  return Curry._7(Generic.sideEffect_encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, v);
}

function sideEffect_decode$1(v) {
  return Curry._7(Generic.sideEffect_decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, v);
}

function errorContext_encode$1(v) {
  return Curry._7(Generic.errorContext_encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, v);
}

function errorContext_decode$1(v) {
  return Curry._7(Generic.errorContext_decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, v);
}

function failure_encode$1(v) {
  return Curry._7(Generic.failure_encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_encode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_encode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, v);
}

function failure_decode$1(v) {
  return Curry._7(Generic.failure_decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.state_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.event_decode, ContentScript__StateMachine__RecordingMode__Types$SmartcutsMacros.ForSerialization.sideEffect_decode, DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, v);
}

function otherFailureReason_encode$1(v) {
  return Curry._1(Generic.otherFailureReason_encode, v);
}

function otherFailureReason_decode$1(v) {
  return Curry._1(Generic.otherFailureReason_decode, v);
}

function failureInfo_encode(v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.Root.FailureInfo.t_encode, state_encode$1, event_encode$1, sideEffect_encode$1, listener_encode$1, otherFailureReason_encode$1, v);
}

function failureInfo_decode(v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.Root.FailureInfo.t_decode, state_decode$1, event_decode$1, sideEffect_decode$1, listener_decode$1, otherFailureReason_decode$1, v);
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "listener_encode"
        ],
        [
          /* Function */0,
          "listener_decode"
        ],
        [
          /* Function */0,
          "state_encode"
        ],
        [
          /* Function */0,
          "state_decode"
        ],
        [
          /* Function */0,
          "event_encode"
        ],
        [
          /* Function */0,
          "event_decode"
        ],
        [
          /* Function */0,
          "sideEffect_encode"
        ],
        [
          /* Function */0,
          "sideEffect_decode"
        ],
        [
          /* Function */0,
          "errorContext_encode"
        ],
        [
          /* Function */0,
          "errorContext_decode"
        ],
        [
          /* Function */0,
          "failure_encode"
        ],
        [
          /* Function */0,
          "failure_decode"
        ],
        [
          /* Function */0,
          "otherFailureReason_encode"
        ],
        [
          /* Function */0,
          "otherFailureReason_decode"
        ],
        [
          /* Function */0,
          "failureInfo_encode"
        ],
        [
          /* Function */0,
          "failureInfo_decode"
        ]
      ]
    }, ForSerialization, {
      listener_encode: listener_encode$1,
      listener_decode: listener_decode$1,
      state_encode: state_encode$1,
      state_decode: state_decode$1,
      event_encode: event_encode$1,
      event_decode: event_decode$1,
      sideEffect_encode: sideEffect_encode$1,
      sideEffect_decode: sideEffect_decode$1,
      errorContext_encode: errorContext_encode$1,
      errorContext_decode: errorContext_decode$1,
      failure_encode: failure_encode$1,
      failure_decode: failure_decode$1,
      otherFailureReason_encode: otherFailureReason_encode$1,
      otherFailureReason_decode: otherFailureReason_decode$1,
      failureInfo_encode: failureInfo_encode,
      failureInfo_decode: failureInfo_decode
    });

var $$let = ExtensionMessaging__FromTab__WithStateMachineDeps$SmartcutsMacros.Make({
      state_encode: ForSerialization.state_encode,
      state_decode: ForSerialization.state_decode,
      event_encode: ForSerialization.event_encode,
      event_decode: ForSerialization.event_decode,
      sideEffect_encode: ForSerialization.sideEffect_encode,
      sideEffect_decode: ForSerialization.sideEffect_decode,
      listener_encode: ForSerialization.listener_encode,
      listener_decode: ForSerialization.listener_decode,
      errorContext_encode: ForSerialization.errorContext_encode,
      errorContext_decode: ForSerialization.errorContext_decode,
      otherFailureReason_encode: ForSerialization.otherFailureReason_encode,
      otherFailureReason_decode: ForSerialization.otherFailureReason_decode
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "message_encode"
              ],
              [
                /* Function */0,
                "message_decode"
              ],
              [
                /* Function */0,
                "response_encode"
              ],
              [
                /* Function */0,
                "response_decode"
              ]
            ]
          },
          "MR_NotifyBgOfContentScriptFailure"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "message_encode"
              ],
              [
                /* Function */0,
                "message_decode"
              ],
              [
                /* Function */0,
                "response_encode"
              ],
              [
                /* Function */0,
                "response_decode"
              ],
              [
                /* Function */0,
                "responseError_encode"
              ],
              [
                /* Function */0,
                "responseError_decode"
              ],
              [
                /* Function */0,
                "result__encode"
              ],
              [
                /* Function */0,
                "result__decode"
              ],
              [
                /* Function */0,
                "respondToSender_encode"
              ],
              [
                /* Function */0,
                "respondToSender_decode"
              ],
              [
                /* Function */0,
                "makeRespondToBg"
              ],
              [
                /* Function */0,
                "encodeAndSendMessage"
              ],
              [
                /* Function */0,
                "encodeAndSendMessageToExtensionId"
              ]
            ]
          },
          "NotifyBgOfContentScriptFailure"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "message_encode"
              ],
              [
                /* Function */0,
                "message_decode"
              ],
              [
                /* Function */0,
                "response_encode"
              ],
              [
                /* Function */0,
                "response_decode"
              ]
            ]
          },
          "MR_NotifyBgOfContentScriptResponseFailure"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "message_encode"
              ],
              [
                /* Function */0,
                "message_decode"
              ],
              [
                /* Function */0,
                "response_encode"
              ],
              [
                /* Function */0,
                "response_decode"
              ],
              [
                /* Function */0,
                "responseError_encode"
              ],
              [
                /* Function */0,
                "responseError_decode"
              ],
              [
                /* Function */0,
                "result__encode"
              ],
              [
                /* Function */0,
                "result__decode"
              ],
              [
                /* Function */0,
                "respondToSender_encode"
              ],
              [
                /* Function */0,
                "respondToSender_decode"
              ],
              [
                /* Function */0,
                "makeRespondToBg"
              ],
              [
                /* Function */0,
                "encodeAndSendMessage"
              ],
              [
                /* Function */0,
                "encodeAndSendMessageToExtensionId"
              ]
            ]
          },
          "NotifyBgOfContentScriptResponseFailure"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "message_encode"
              ],
              [
                /* Function */0,
                "message_decode"
              ],
              [
                /* Function */0,
                "response_encode"
              ],
              [
                /* Function */0,
                "response_decode"
              ]
            ]
          },
          "MR_All"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "message_encode"
              ],
              [
                /* Function */0,
                "message_decode"
              ],
              [
                /* Function */0,
                "response_encode"
              ],
              [
                /* Function */0,
                "response_decode"
              ]
            ]
          },
          "All"
        ]
      ]
    }, ExtensionMessagingFromTabWithStateMachineDeps, {
      MR_NotifyBgOfContentScriptFailure: $$let.MR_NotifyBgOfContentScriptFailure,
      NotifyBgOfContentScriptFailure: $$let.NotifyBgOfContentScriptFailure,
      MR_NotifyBgOfContentScriptResponseFailure: $$let.MR_NotifyBgOfContentScriptResponseFailure,
      NotifyBgOfContentScriptResponseFailure: $$let.NotifyBgOfContentScriptResponseFailure,
      MR_All: $$let.MR_All,
      All: $$let.All
    });

function message_encode(v) {
  if (v.TAG === /* Message_FromTabWithStateMachineDeps */0) {
    return [
            "Message_FromTabWithStateMachineDeps",
            Curry._1(ExtensionMessagingFromTabWithStateMachineDeps.All.message_encode, v._0)
          ];
  } else {
    return [
            "Message_FromTab",
            ExtensionMessaging__FromTab$SmartcutsMacros.All.message_encode(v._0)
          ];
  }
}

function message_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Message_FromTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ExtensionMessaging__FromTab$SmartcutsMacros.All.message_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_FromTab */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Message_FromTabWithStateMachineDeps" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(ExtensionMessagingFromTabWithStateMachineDeps.All.message_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_FromTabWithStateMachineDeps */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode(v) {
  if (v.TAG === /* Response_FromTabWithStateMachineDeps */0) {
    return [
            "Response_FromTabWithStateMachineDeps",
            Curry._1(ExtensionMessagingFromTabWithStateMachineDeps.All.response_encode, v._0)
          ];
  } else {
    return [
            "Response_FromTab",
            ExtensionMessaging__FromTab$SmartcutsMacros.All.response_encode(v._0)
          ];
  }
}

function response_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Response_FromTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ExtensionMessaging__FromTab$SmartcutsMacros.All.response_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_FromTab */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Response_FromTabWithStateMachineDeps" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(ExtensionMessagingFromTabWithStateMachineDeps.All.response_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_FromTabWithStateMachineDeps */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var responseError_encode = Decco.stringToJson;

var responseError_decode = Decco.stringFromJson;

var res_encode = response_encode;

var res_decode = response_decode;

var resError_encode = Decco.stringToJson;

var resError_decode = Decco.stringFromJson;

var include = ExtensionMessagingBuilders$SmartcutsMacros.MakeResponderTypesWithDeccoSupport({
      res_encode: res_encode,
      res_decode: res_decode,
      resError_encode: resError_encode,
      resError_decode: resError_decode
    });

var result__encode = include.result__encode;

function onMessageToExtension(listener) {
  browser.runtime.onMessage.addListener(function (json, sender) {
        var msg = message_decode(json);
        if (msg.TAG === /* Ok */0) {
          return Curry._2(listener, msg._0, sender).then(function (result) {
                      return Promise.resolve(Curry._1(result__encode, result));
                    });
        }
        Curry._3(Log$SmartcutsMacros.decco.error3, "decodeError", msg._0, json);
        return Promise.resolve(Curry._1(result__encode, {
                        TAG: /* Error */1,
                        _0: "Error decoding message from tab"
                      }));
      });
  
}

function onMessageExternal(listener) {
  browser.runtime.onMessageExternal.addListener(function (json, sender) {
        var msg = message_decode(json);
        if (msg.TAG === /* Ok */0) {
          return Curry._2(listener, msg._0, sender).then(function (result) {
                      return Promise.resolve(Curry._1(result__encode, result));
                    });
        }
        Curry._3(Log$SmartcutsMacros.decco.error3, "decodeError", msg._0, json);
        return Promise.resolve(Curry._1(result__encode, {
                        TAG: /* Error */1,
                        _0: "Error decoding message from tab"
                      }));
      });
  
}

function makeNestedRespondToTabFromRootRespondToTab(wrapResponseAsAllResponse, respondToTab) {
  return function (result) {
    return respondToTab(Belt_Result.map(result, (function (response) {
                      return {
                              TAG: /* Response_FromTab */1,
                              _0: Curry._1(wrapResponseAsAllResponse, response)
                            };
                    })));
  };
}

function makeRootRespondToTabFromNestedRespondToTab(extractNestedResponseFromAllResponse, expectedAllResponse, nestedRespondToTab) {
  return function (result) {
    if (result.TAG !== /* Ok */0) {
      return Curry._1(nestedRespondToTab, {
                  TAG: /* Error */1,
                  _0: result._0
                });
    }
    var allResponse = result._0;
    if (allResponse.TAG === /* Response_FromTabWithStateMachineDeps */0) {
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected only Response_FromTab(" + (expectedAllResponse + ")"));
    }
    var nestedResponse = Curry._1(extractNestedResponseFromAllResponse, allResponse._0);
    if (nestedResponse !== undefined) {
      return Curry._1(nestedRespondToTab, {
                  TAG: /* Ok */0,
                  _0: Caml_option.valFromOption(nestedResponse)
                });
    } else {
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected only Response_FromTab(" + (expectedAllResponse + ")"));
    }
  };
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "message_encode"
        ],
        [
          /* Function */0,
          "message_decode"
        ],
        [
          /* Function */0,
          "response_encode"
        ],
        [
          /* Function */0,
          "response_decode"
        ],
        [
          /* Function */0,
          "responseError_encode"
        ],
        [
          /* Function */0,
          "responseError_decode"
        ],
        [
          /* Function */0,
          "result__encode"
        ],
        [
          /* Function */0,
          "result__decode"
        ],
        [
          /* Function */0,
          "respondToSender_encode"
        ],
        [
          /* Function */0,
          "respondToSender_decode"
        ],
        [
          /* Function */0,
          "onMessageToExtension"
        ],
        [
          /* Function */0,
          "onMessageExternal"
        ],
        [
          /* Function */0,
          "makeNestedRespondToTabFromRootRespondToTab"
        ],
        [
          /* Function */0,
          "makeRootRespondToTabFromNestedRespondToTab"
        ]
      ]
    }, ExtensionMessagingFromTabAll, {
      message_encode: message_encode,
      message_decode: message_decode,
      response_encode: response_encode,
      response_decode: response_decode,
      responseError_encode: responseError_encode,
      responseError_decode: responseError_decode,
      result__encode: result__encode,
      result__decode: include.result__decode,
      respondToSender_encode: include.respondToSender_encode,
      respondToSender_decode: include.respondToSender_decode,
      onMessageToExtension: onMessageToExtension,
      onMessageExternal: onMessageExternal,
      makeNestedRespondToTabFromRootRespondToTab: makeNestedRespondToTabFromRootRespondToTab,
      makeRootRespondToTabFromNestedRespondToTab: makeRootRespondToTabFromNestedRespondToTab
    });

var Regular = {};

exports.Generic = Generic;
exports.ForSerialization = ForSerialization;
exports.ExtensionMessagingFromTabWithStateMachineDeps = ExtensionMessagingFromTabWithStateMachineDeps;
exports.ExtensionMessagingFromTabAll = ExtensionMessagingFromTabAll;
exports.Regular = Regular;
/* Generic Not a pure module */
